export default __webpack_public_path__ + "static/media/export.8f27da94.svg";